export const SET_USER = "user";
export const SET_METADATA = "metadata";
export const FETCH_NOTIFICATIONS = "notifications";
export const CLEAR_USERS_REDUCER = "clear_users";